# markery zacatku a konce naplanovane jizdy
start = 'start'
end = 'start'

create_hash = ->
  Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 10)

reload_ride = ->
  $.ajax(
    url: '/ajax/reload_ride.script'
    type: 'POST'
    dataType: 'JSON'
    data: 
      ride_hash: $('#ride_hash').val()
  ).done((data) ->
    console.log data

    if start != 'start'
      start.setMap(null)
    if end != 'start'
      end.setMap(null)


    # if data.ride_data.ride.scheduled_start_lat > 0
    #   latLng = 
    #     lat: parseFloat(data.ride_data.ride.scheduled_start_lat)
    #     lng: parseFloat(data.ride_data.ride.scheduled_start_lng)
    #   start = new google.maps.Marker
    #     position: latLng,
    #     map: status_map,
    #     icon: '../images/start.png'
    
    # if data.ride_data.ride.scheduled_end_lat > 0
    #   latLng = 
    #     lat: parseFloat(data.ride_data.ride.scheduled_end_lat)
    #     lng: parseFloat(data.ride_data.ride.scheduled_end_lng)
    #   start = new google.maps.Marker
    #     position: latLng,
    #     map: status_map,
    #     icon: '../images/end.png'


    $("#active_ride").html(data.html_output)

    return
  ).fail (jqXHR) ->
    console.log  'Stack sending ERROR: ' + jqXHR.responseText
    return

set_ride_hash = ->
  hash = create_hash()
  $('#ride_hash').val hash
  return hash

get_ride_hash = ->
  return $('#ride_hash').val()


active_ride = ->
  if $('#ride_hash').val() != ''
    true
  else
    false

waiting = ->
  actual_sec = $('input[name=]')

get_active_ride = ->
  if Cookies.get 'active_ride'
    hash = Cookies.get 'active_ride'
    $('#ride_hash').val hash
    $('#taxametr_info').val Cookies.get 'taxametr_info'
    $('#taxametr_servis').val Cookies.get 'taxametr_info'
    $('#taxametr_price').val Cookies.get 'taxametr_price' 
  else
    hash = set_ride_hash()
    Cookies.set 'active_ride', hash
    Cookies.set 'taxametr_info', 0
    $('#ride_hash_info').val hash
    $('#taxametr_info').val 0
    command 'start'  
  return 

$(document).on 'click', '.create_ride', ->

  ride_data = {}
  ride_data.start_price = $(@).data 'start_price'
  ride_data.km_price = $(@).data 'km_price'
  ride_data.taxametr_start = $(@).data 'taxametr_start'
  ride_data.ride_hash = $(@).data 'ride_hash'
  ride_data.customer = $(@).data 'customer'
  

  ride_data.planned_ride = $(@).data 'planned_ride'
  ride_data.planned_ride_hash = $(@).data 'planned_ride_hash'

  if $(@).data('create_type') == 'plan_only'
    start_planned_ride(ride_data)
    console.log 'plan_only'
    
    $(@).remove()
    return false


  # planovanou jizdu po prijetui odstranime
  if ride_data.planned_ride == '1'
    $(@).remove()

  start_ride(ride_data)

  return false


$(document).on 'click', 'a.ride_data_changer', ->
    update_ride_data($(@).data('variable'), $(@).data('value'), $(@).data('ride_hash'))
    return false

$(document).on 'change', 'select.ride_data_changer', ->
    update_ride_data($(@).data('variable'), $(@).val(), $(@).data('ride_hash'))
    return false


update_ride_data = (variable, value, ride_hash) ->

  console.log variable, value, ride_hash

  if online()
    $.ajax(
      url: '/ajax/update_ride.script'
      type: 'POST'
      dataType: 'JSON'
      data: 
        variable: variable
        value: value
        ride_hash: ride_hash
    ).done((data) ->
      console.log data
      reload_ride()
      if variable == 'user'
        show_modal($('.show_modal[data-modal=food_delivery]'))
      # po uprave real paymentu reloadnem celej last ride, kvuli mozne platbe z kreditu
      if variable == 'real_payment'
        get_last_ride_info()
      return
    ).fail (jqXHR) ->
      console.log  'Stack sending ERROR: ' + jqXHR.responseText
      return

start_planned_ride = (ride_data) ->
  $.ajax(
    url: '/ajax/create_planned_ride.script'
    type: 'POST'
    dataType: 'JSON'
    data: 
      ride_data: ride_data
  ).done((data) ->
    console.log data
    
    # reloadRideQueue()

    return
  ).fail (jqXHR) ->
    console.log  'Stack sending ERROR: ' + jqXHR.responseText
    return

update_ride_customer = (customer) ->
  if active_ride() && online()

    update_ride_data('customer', customer, get_ride_hash())

    # $.ajax(
    #   url: '/ajax/update_ride.script'
    #   type: 'POST'
    #   dataType: 'JSON'
    #   data: 
    #     ride_hash: get_ride_hash()
    #     customer: customer
    # ).done((data) ->
    #   console.log data
    #   reload_ride()
    #   return
    # ).fail (jqXHR) ->
    #   console.log  'Stack sending ERROR: ' + jqXHR.responseText
    #   return



start_ride = (ride_data) ->
  console.log 'start_ride', ride_data

  $('#message').removeClass 'shown'

  # pokud neni aktivni jizda tak zalozime novou a vsechny jeji parametry ulozime do cookin a do servisnich inputu

  if !active_ride()
    # data musi byt pole s vychozima vecma, takze ID, klient id, ceny, vychozi cisla, jestli ma nebo nema byt zapnuty taxametr
    $('#bottom_menu .link.ride').removeClass 'hidden'
    $('#top_stripe .ride_info').removeClass 'hidden'
    $('#top_stripe .user_info').addClass 'hidden'

    $('#waiting_servis').val(0)
    $('#waiting_timer').val(0)

    run_timer(1000)

    if !ride_data.ride_hash?
      ride_data.ride_hash = create_hash()

    if parseInt(ride_data.taxametr_start) == 1
      console.log 'autostart'
    else 
      $('#taxametr_status').removeClass 'on'
      $('#taxametr_status').addClass 'off'
    
    $('#waiting_servis').val 0
    $('#waiting_price_servis').val 0
    $('#timer_servis').val 0
    $('#taxametr_waiting_status').removeClass 'on'
    $('#taxametr_waiting_status').addClass 'off'


    if ride_data.customer
      $('#client_id').val ride_data.customer

    start_taxametr(1000)
    track_position(5000)
    check_planned_ride(0)

    
    $('#ride_hash').val ride_data.ride_hash
    Cookies.set 'taxametr_info', 0

    $('#taxametr_info').val 0
    if ride_data.km_price > 0
      $('#taxametr_km_price').val ride_data.km_price
    if ride_data.start_price > 0
      $('#taxametr_start_price').val ride_data.start_price

    $('#top_stripe .ride_info a').text ride_data.ride_hash

    set_hash 'active_ride'

    position = {}

    position.lat = $('input#lat').val()
    position.lng = $('input#lng').val()

    $('#taxametr_waiting_price').val 4


    #  kdyz je online zalozim kompleti jizdu
    if online()
      $.ajax(
        url: '/ajax/create_ride.script'
        type: 'POST'
        dataType: 'JSON'
        data: 
          ride_data: ride_data
          position: position
      ).done((data) ->

        console.log 'CREATE RRRAJD'
        console.log data

        reloadRideQueue()

        navigation('active_ride')
        hide_modal()

        reload_ride()

        # location.reload();


        return
      ).fail (jqXHR) ->
        console.log  'Stack sending ERROR: ' + jqXHR.responseText
        return
    else
      # posilame jen do stacku
      start_taxametr(1000)
      track_position(5000)

      $('#ride_hash_info').val hash
      $('#taxametr_info').val 0
      $('#taxametr_servis').val 0
      addToStack('start')
  else

    navigation('active_ride')

  return


$(document).on 'click', '.pickup_order', ->

  loading()
  $.ajax(
    url: '/ajax/pickup_order.script'
    type: 'POST'
    dataType: 'JSON'
    data: 
      ride_hash: get_ride_hash()
  ).done((data) ->
    console.log data
    $("#active_ride").html(data.html_output)
    loading_stop()
    return
  ).fail (jqXHR) ->
    console.log  'Stack sending ERROR: ' + jqXHR.responseText
    return


$(document).on 'click', '.end_ride', ->

  ride_data = {}
  ride_data.start_price = $(@).data 'start_price'
  ride_data.km_price = $(@).data 'km_price'
  ride_data.taxametr_start = $(@).data 'taxametr_start'
  ride_data.ride_hash = $(@).data 'ride_hash'

  end_ride()

  return false
end_ride = ->

    start_taxametr(0)
    check_planned_ride(5000)
    track_position(15000)
    run_timer(0)


    $('#bottom_menu .link.ride').addClass 'hidden'
    $('#top_stripe .ride_info').addClass 'hidden'
    $('#top_stripe .user_info').removeClass 'hidden'
    $('#top_stripe .user_info a').text ''
    
    position = {}

    position.lat = $('input#lat').val()
    position.lng = $('input#lng').val()



    ride_data =
      taxametr_distance: $('input#taxametr_servis').val()
      taxametr_price: $('input#taxametr_price_servis').val()
      taxametr_waiting: $('input#waiting_servis').val()
      taxametr_waiting_price: $('input#waiting_price_servis').val()
      # timer: $('input#timer_servis').val()

    if online()
      loading()
      $.ajax(
        url: '/ajax/end_ride.script'
        type: 'POST'
        dataType: 'JSON'
        data: 
          ride_hash: get_ride_hash()
          ride_data: ride_data
          position: position
      ).done((data) ->
        console.log data
        
        $('#active_ride').html('')

        # vymazem vsechny minule zaznamy
        $('#client_info').html ''
        $('#ride_summary_container').html ''

        get_last_ride_info(get_ride_hash())

        $('#ride_hash').val ''
        $('#client_id').val ''

        $('#taxametr_servis').val ''
        $('#waiting_servis').val 0
        $('#waiting_price_servis').val 0

        $('#timer_servis').val 0
        $('#taxametr_price_servis').val ''
        $('#taxametr_info').val '0'
        $('#taxametr_price').val '0'
        $('#display_waiting').val '0'
        $('#display_waiting_price').val '0'

        Cookies.set 'taxametr_info', 0

        navigation('ride_summary')
        return
      ).fail (jqXHR) ->
        console.log  'Stack sending ERROR: ' + jqXHR.responseText
        return
    else 
      console.log 'stop do stacku'


    return


$('#reset_ride').click ->
  stop_ride()
  navigation()
  return false

get_last_ride_info = (hash) ->

  if !hash
    hash = get_ride_hash()

  if online()

    $.ajax(
      url: '/ajax/get_ride_info.script'
      type: 'POST'
      dataType: 'JSON'
      data: 
        ride_hash: hash
    ).done((data) ->
      console.log data
      loading_stop()


      $("#ride_summary_container").html(data.html_output)


      if document.getElementById('summary_map') && not maps['summary_map']
        summary_map = initMap('summary_map')
        maps['summary_map'] = summary_map

      clearMap(maps['summary_map'])


      showOnMap(maps['summary_map'], data.result.ride.start_lat, data.result.ride.start_lng, 'start.png')
      showOnMap(maps['summary_map'], data.result.ride.end_lat, data.result.ride.end_lng, 'end.png')

      showOnMapPath(maps['summary_map'], data.path)

      setTimeout ->
        maps['summary_map'].invalidateSize()

        setTimeout ->
          fitMap(maps['summary_map'])
        , 100  # vnitřní timeout na bezpečné fitnutí

      , 100  # vnější timeout na přepočet velikosti


      # maps['summary_map'].invalidateSize();



      return
    ).fail (jqXHR) ->
      console.log 'error: '+jqXHR.responseText
      return
  else 
    console.log 'stop do stacku'

  return  